/**
 * Shared auto-select behavior for select components.
 *
 * When exactly one item is available and auto-select is not prevented,
 * automatically selects that item. When multiple items appear and
 * resetOnMultiple is enabled, clears the selection.
 *
 * Extracted from AliyahSelect, HaftarahSelect, ParashahSelect, and
 * SentenceGroupSelect which all duplicated this identical watchEffect.
 */
import type { ComputedRef, Ref } from 'vue'
import { watchEffect } from 'vue'

/**
 * Set up auto-select-single-item behavior for select components.
 * Call inside onMounted() to match existing component lifecycle patterns.
 */
export function setupAutoSingleSelect<T>(opts: {
  filteredItems: ComputedRef<T[]> | Ref<T[]>
  preventAutoSelect: () => boolean
  resetOnMultiple: () => boolean
  setSelected: (item: T | null) => void
}) {
  watchEffect(() => {
    if (opts.filteredItems.value.length === 1 && !opts.preventAutoSelect()) {
      opts.setSelected(opts.filteredItems.value[0])
    } else if (opts.resetOnMultiple()) {
      opts.setSelected(null)
    }
  })
}
